"use client";

import { KeyPrefix, Namespace } from "i18next";
import i18next from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { useEffect } from "react";
import { FallbackNs, UseTranslationOptions } from "react-i18next";
import { initReactI18next, useTranslation as useTranslationOrg } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { fallbackLng, getOptions, getResources, languages } from "./settings";
import { czechTypographyPostProcessor } from "./czechTypographyPlugin";

const runsOnServerSide = typeof window === "undefined";

void i18next
  .use(czechTypographyPostProcessor)
  .use(initReactI18next)
  // .use(LanguageDetector)
  .use(resourcesToBackend(getResources))
  .init({
    ...getOptions(),
    lng: undefined, // let detect the language on client side
    detection: {
      order: ["path", "htmlTag", "cookie", "navigator"],
    },
    preload: runsOnServerSide ? languages : [],
    postProcess: ["czechTypography"],
  });

export function useTranslation<Ns extends Namespace, KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined>(
  // lng: string,
  ns?: Ns,
  options?: UseTranslationOptions<KPrefix>
) {
  const lng = fallbackLng;
  const ret = useTranslationOrg(ns, options);
  const { i18n } = ret;
  if (runsOnServerSide && i18n.resolvedLanguage !== lng) {
    void i18n.changeLanguage(lng);
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (i18n.resolvedLanguage === lng) {
        return;
      }

      void i18n.changeLanguage(lng);
    }, [lng, i18n]);
  }
  return ret;
}
